<template>
    <div>
        <v-card v-if="datosArt" elevation="0">
            <v-toolbar color="#ef6b01" rounded="0" elevation="5" class="fixed-bar">
                <v-btn icon dark @click="atras"><font-awesome-icon style="font-size:23px" icon="arrow-left"/></v-btn>
                <v-card-title style="color:#ffff">Detalles del producto</v-card-title>
                <v-spacer></v-spacer>
                <v-menu left offset-y :z-index="300">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon dark v-bind="attrs" v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item @click="onFavorito">
                            <v-list-item-title>Favorito</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="onAccesoRapido">
                            <v-list-item-title>Acceso rápido</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar>
            <div :style="(artComp.length>0)?'margin-inline: 15px;margin-bottom:140px':'margin-inline: 15px;margin-bottom: 25px;'" class="mt-5">
                <p><b>{{(datosArt.DESC_CLIENTE)?datosArt.DESC_CLIENTE:datosArt.DESCRIPCION}}</b> </p>
                <div v-if="this.imagenes.length>=0" style="justify-content: center; display: grid;" >
                    <v-carousel class="caroucel" height="200" hide-delimiter-background hide-delimiters :show-arrows="(this.imagenes.length>1)?true:false" style="max-width: 500px;">
                        <v-img v-if="datosArt.etiqueta" style="position:absolute; z-index: 1; max-width: 100px; max-height: 30px;" contain :src="datosArt.etiqueta"/>
                        <v-carousel-item
                        height="auto"
                        v-for="(item,i) in this.imagenes"
                        :key="i"
                        :src="item.url"
                        >
                            <div v-if="(item.tipo!='VIDEO')" class="d-flex flex-column justify-end align-center fill-height">
                                <v-btn large icon color="orange" @click="verImagen(item.url)"><v-icon>mdi-magnify-plus-outline</v-icon></v-btn>
                            </div>
                            <iframe v-if="(item.tipo=='VIDEO')" :src="item.url"  frameborder="0" width="100%" height="100%" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                        </v-carousel-item>
                    </v-carousel>
                </div>
                <v-divider class="orange" style="border-width: 1px" dark></v-divider>
                <div class="mt-5">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <td style="font-size:18px; font-weight: bold;">Código</td>
                                <td style="font-weight: bold; color:#ef6b01;font-size:17px">{{datosArt.COD_ART}}</td>
                            </tr>
                            <tr>
                                <td style="font-size:18px; font-weight: bold;">EAN</td>
                                <td style="font-weight: bold; color:#ef6b01; font-size:17px">{{datosArt.EAN}}</td>
                            </tr>
                            <tr>
                                <td style="font-size:18px; font-weight: bold;">Empaque</td>
                                <td style="font-weight: bold; color:#ef6b01; font-size:17px">{{(datosArt.ESCALA!=datosArt.ESC)?datosArt.ESCALA:''}} {{(datosArt.ALQ_CANT_USO_DIARIO)? datosArt.ALQ_CANT_USO_DIARIO : datosArt.CANT_EMPAQ}} {{datosArt.ESC}}</td>
                            </tr>
                            <template v-if="datosArt.COL_PRI_ID!=1">
                                <tr v-if="usuario.muestra_lista==1">
                                    <td style="font-size:18px; font-weight: bold;">Precio por {{ datosArt.ESC_UNI }} contado</td>
                                    <td style="font-weight: bold; color:#ef6b01; font-size:17px">{{precioArt() | toCurrency}}<span v-if="precioConIva" style="color:#ef6b01;font-size: 13px;font-weight: 400;">{{` más IVA (${porcentajeIva()}%)`}}</span></td>
                                </tr>
                                <tr v-if="(datosArt.CANT_EMPAQ!=1 || datosArt.ALQ_CANT_USO_DIARIO>0) && usuario.muestra_lista==1">
                                    <td style="font-size:18px; font-weight: bold;">Precio por {{ datosArt.ESC_EMP }} contado</td>
                                    <td style="font-weight: bold; color:#ef6b01; font-size:17px">{{precioPorEmpaque() | toCurrency}}<span v-if="precioConIva" style="color:#ef6b01;font-size: 13px;font-weight: 400;">{{` más IVA (${porcentajeIva()}%)`}}</span></td>
                                </tr>
                            </template>
                        </tbody>
                    </v-simple-table>
                </div>
                <v-divider class="orange mb-2" style="border-width: 1px" dark></v-divider>
                <div style="justify-content: end; display: grid;" v-if="datosArt.COL_PRI_ID!=1">
                    <v-btn v-if="(carrito.findIndex(i => i.cod_art==datosArt.COD_ART)==-1)" color="orange" @click="agregar()" elevation="0" outlined dark style="max-width: 115px;"><font-awesome-icon style="font-size:22px" icon="cart-shopping"/>{{(usuario.muestra_lista==1)?'Agregar':'Cotizar'}}</v-btn>
                    <template v-if="(carrito.findIndex(i => i.cod_art==datosArt.COD_ART)!=-1)">
                        <p style="color:green;text-align: center;margin: 0px;" class="mt-2"><v-icon style="font-size:20px" color="green">mdi-cart-check</v-icon>Agregado al carrito</p>
                        <div class="cantidad-controls mt-3">
                            <v-btn color="orange" fab icon small @click="cantidadMenos(datosArt)"><v-icon>mdi-minus-thick</v-icon></v-btn>
                            <v-text-field
                            v-model="carrito[carrito.findIndex(i => i.cod_art==datosArt.COD_ART)].cantidad"
                            label="Cantidad" type="number"
                            dense flat solo readonly
                            color="orange" style="max-width: 97px;" class="cant centered-input text-orange cantidad-input"
                            @click="clicCant"
                            ></v-text-field>
                            <v-btn color="orange" fab icon small @click="cantidadMas(datosArt)"><v-icon>mdi-plus-thick</v-icon></v-btn>
                        </div>
                        <p style="color:orange;text-align: center;max-width: 168px;">{{descEmpaque(datosArt)}}</p>
                    </template>
                </div>
                    
                <v-row style="    align-items: end;" no-gutters>
                    <h2 class="mt-5" style="height: 30px;">Descripción</h2> <v-btn @click="pedidoAsesoramiento(datosArt)" v-if="datosArt.CURVADET_ID==1" class="ml-3" color="orange" small outlined>Asesoramiento!</v-btn>
                </v-row>
                <v-textarea v-if="datosArt.NOTA!=null" v-model="datosArt.NOTA" filled full-width auto-grow class="mt-5" style="font-size: large;" outlined readonly color="orange" />
            </div>
            <v-footer padless fixed class="mt-5" rounded="0">
                <v-card class="flex" dense flat tile>
                    <v-card-title class="white text-center justify-center" style="padding: 0px;">
                        <v-sheet class="mx-auto" elevation="0" style="max-width: 100vw" v-if="artComp.length>0">
                            <v-slide-group mobile-breakpoint="600"  show-arrows="desktop" style="margin-bottom:8px">
                                <v-slide-item v-for="(item,index) in artComp" :key="index" class="mx-2" v-slot="{ active }">
                                    <!-- <v-img :src="item.recurso" height="80"  width="80" style="border: ridge;"></v-img> -->
                                    <v-card elevation="5"  :input-value="active" @click="clicArtComp(item)">
                                            <v-img :src="`${item.imagen}`" height="80"  width="80" :key="componentKey"  @error="onErrorImg(item)"></v-img>
                                    </v-card>
                                </v-slide-item>
                            </v-slide-group>
                        </v-sheet>
                    </v-card-title>

                    <v-card-text class="py-2 text-end justify-end" style="background-color:#ef6b01;height: 44px;padding: 0px;">
                        <v-row justify="center" no-gutters>
                            <v-col></v-col>
                            <v-col class="text-center">
                                <v-btn style="bottom: 31px;" fab color="#ef6b01" elevation="20" @click="irHome" class="my-2"><font-awesome-icon style="font-size:25px;color: white" icon="plus"/></v-btn>
                            </v-col>
                            <v-col class="text-end">
                                <v-btn @click="irCarrito" icon class="my-1 mr-2" color="white" style="height: auto;"><font-awesome-icon style="font-size:22px;color: white;" icon="cart-shopping"/>{{(carrito.length>0)?carrito.length:''}}</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    </v-card>
                
            </v-footer>
            <!-- SNACKBAR -->
            <v-snackbar v-model="snackbar" class="mb-15" :color="snackbarColor" text outlined>
                {{ snackbarMsge }}
                <template v-slot:action="{ attrs }">
                    <v-btn icon :color="snackbarColor" text v-bind="attrs" @click="snackbar = false"><v-icon>{{snackbarIcon}}</v-icon></v-btn>
                </template>
            </v-snackbar>
        </v-card>
        <!-- DIALOG CANTIDAD -->
        <v-dialog v-model="dialogCantidad" max-width="300px" persistent>
            <v-card v-if="datosArt">
                <v-toolbar color="#ef6b01">
                    <v-btn icon dark @click="cerrarDialogCambiarCantidad"><font-awesome-icon style="font-size:23px" icon="arrow-left"/></v-btn>
                    <v-card-title style="color:#ffff">Cambiar cantidad</v-card-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="mt-3" v-if="(carrito.findIndex(i => i.cod_art==datosArt.COD_ART)>=0)">
                    <v-text-field autofocus outlined style="font-size: 20px;" v-model="carrito[carrito.findIndex(i => i.cod_art==datosArt.COD_ART)].cantidad" label="Cantidad" type="number" solo color="orange" @focus="$event.target.select()"></v-text-field>
                    <p v-if="sinDisponibilidadCantidad" style="color:red;text-align:center;margin:0">Sin disponibilidad para esa cantidad</p>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="orange" elevation="5" outlined @click="cambiarCantidad()" :disabled="!validarCantidad">Aceptar</v-btn>
                    <v-btn color="grey" elevation="5" @click="cerrarDialogCambiarCantidad" outlined>Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- DIALOG VER IMAGEN  -->
        <v-dialog v-model="dialogVerImagen" v-if="imagenSelected" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar color="#ef6b01">
                    <v-btn icon dark @click="dialogVerImagen = false"><v-icon>mdi-arrow-left</v-icon></v-btn>
                </v-toolbar>
                <v-card-actions class="d-flex justify-end" style="padding-bottom:0px">
                    <v-btn icon @click="dialogVerImagen = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-actions>
                <ImagenZoom :imagen="imagenSelected" v-if="dialogVerImagen"/>
                <v-footer color="#ef6b01" padless fixed class="mt-5" style="height: 30px;" rounded="0"></v-footer>
            </v-card>
        </v-dialog>
        <!-- DIALOG ASESORAMIENTO -->
        <v-dialog v-model="dialogAsesoramiento" max-width="600px" persistent>
            <v-card class="mx-auto">
                <div style="padding: 10px;">
                    <p  style="font-weight: 600; font-size: larger;"><v-icon color="orange">mdi-check-circle</v-icon> ¡Gracias por tu interés!</p>
                    <span>Nos contactaremos para brindarte el asesoramiento que requieres sobre este producto</span>
                </div>
                <v-card-actions>
                    <v-btn color="grey" elevation="5" @click="dialogAsesoramiento = false" outlined>Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- DIALOG ACCESO RAPIDO -->
        <v-dialog v-model="dialogAccesoRapido" max-width="400px" persistent>
            <v-card>
                <v-toolbar color="#ef6b01">
                    <v-btn icon dark @click="dialogAccesoRapido = false"><font-awesome-icon style="font-size:23px" icon="arrow-left"/></v-btn>
                    <v-card-title style="color:#ffff">Acceso rápido</v-card-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="mt-3">
                    <v-text-field
                        autofocus
                        outlined
                        v-model="textoAccesoRapido"
                        label="Texto de acceso rápido"
                        color="orange"
                        maxlength="80"
                        counter="80"
                        @keyup.enter="guardarAccesoRapido"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="orange" elevation="5" outlined @click="guardarAccesoRapido" :disabled="!(textoAccesoRapido && textoAccesoRapido.trim())">Guardar</v-btn>
                    <v-btn v-if="tieneAccesoRapido" color="error" elevation="5" outlined @click="eliminarAccesoRapido">Eliminar</v-btn>
                    <v-btn color="grey" elevation="5" outlined @click="dialogAccesoRapido = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <!-- ----CARGANDO------- -->
        <v-overlay :value="cargando">
            <v-progress-circular
                indeterminate
                size="70"
                width="7"
            ></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import ApiServer from '../api';
import Imagen from '../components/Imagen.vue'
import ImagenZoom from '../components/ImagenZoom.vue';
import moment from 'moment';
import {mapActions, mapState} from 'vuex'
import * as stockGrupo from '../stockGrupo'
export default {
    name:'Articulo',
    components:{Imagen,ImagenZoom},
    props:{datosArticulo: {type: Object}},
    data(){
        return{
            datosArt:[],
            imagenes:[],
            artComp:[],
            menuOtrasOpciones:false,
            snackbar:false,
            snackbarMsge:'',
            snackbarColor:'error',
            snackbarIcon:'mdi-close-circle',
            dialogCantidad:false,
            cargando:false,
            componentKey:0,
            imagenSelected: null,
            dialogVerImagen: false,
            dialogAsesoramiento:false,
            dialogAccesoRapido: false,
            textoAccesoRapido: '',
            tieneAccesoRapido: false,
        }
    },
    methods:{
        ...mapActions(['editarLista','agregarAlCarrito','editarCantCarrito','borrarArtCarrito']),
        obtenerGrupoStockId(item){
            return stockGrupo.obtenerGrupoStockId(item)
        },
        obtenerDisponible(item){
            return stockGrupo.obtenerDisponibleEnUnidades(item)
        },
        obtenerEmpaque(item){
            return stockGrupo.obtenerEmpaque(item)
        },
        cantidadTotalGrupoEnCarrito(grupoId, codArtExcluir = null){
            return stockGrupo.cantidadTotalGrupoEnCarrito(this.carrito, grupoId, codArtExcluir)
        },
        puedeAsignarCantidadPorGrupo(item, cantidadDeseada){
            return stockGrupo.puedeAsignarCantidadPorGrupo(item, cantidadDeseada, this.carrito)
        },
        disponibleGrupoParaItem(item){
            return stockGrupo.disponibleGrupoParaItem(item, this.carrito)
        },
        async agregar(){
            this.cargando = true
            try {
                if(!this.puedeAsignarCantidadPorGrupo(this.datosArt,1)){
                    this.cargando = false
                    this.snackbar = true
                    this.snackbarColor ='error'
                    this.snackbarIcon = 'mdi-close-circle'
                    this.snackbarMsge='Sin stock compartido disponible'
                    return
                }
                let result = await ApiServer.postCarritoCliente({
                    cod_cli:this.usuario.cod_cli,
                    cod_art:this.datosArt.COD_ART,
                    cantidad: 1,
                    lpr_id:this.datosArt.LISTA_ID,
                    usuario: this.usuario.nombreUsuario,
                    accion:'CARRITO'
                });
                this.agregarAlCarrito({
                    id:result.insertId,
                    lpr_id:this.datosArt.LISTA_ID,
                    cod_art:this.datosArt.COD_ART,
                    art_id:this.datosArt.ART_ID,
                    desc_cliente: this.datosArt.DESC_CLIENTE,
                    descripcion: this.datosArt.DESCRIPCION,
                    mod:this.datosArt.MOD,
                    med:this.datosArt.MED,
                    cantidad:1,
                    escala_id:this.datosArt.ESCALA_ID,
                    escala:this.datosArt.ESCALA,
                    esc:this.datosArt.ESC,
                    esc_plu:this.datosArt.ESC_PLU,
                    esc_uni: this.datosArt.ESC_UNI,
                    esc_emp: this.datosArt.ESC_EMP,
                    pr_vta:this.datosArt.PR_VTA,
                    pr_cto_cpra:this.datosArt.PR_CTO_CPRA,
                    pr_cto:this.datosArt.PR_CTO,
                    pr_final:this.datosArt.PR_FINAL,
                    descuento:this.datosArt.DESCUENTO,
                    disponible:this.datosArt.DISPONIBLE,
                    cant_empaq:this.datosArt.CANT_EMPAQ,
                    alq_cant_uso_diario: this.datosArt.ALQ_CANT_USO_DIARIO,
                    ord_rec_str:this.datosArt.ORD_REC_STR,
                    ean:this.datosArt.EAN,
                    imagen : `https://loguin.com.ar/img/${this.datosArt.ART_ID}.jpg`,
                    etiqueta : this.datosArt.etiqueta,
                    peso: this.datosArt.PESO
                })
                this.cargando = false
            } catch (error) {
                console.log(error);
                this.cargando = false
            }
        },
        async cantidadMas(item){
            this.cargando = true
            try {
                let index = this.carrito.findIndex(i => i.cod_art==item.COD_ART)
                let cant = this.carrito[index].cantidad+1
                if(this.puedeAsignarCantidadPorGrupo(this.carrito[index],cant)){
                    await ApiServer.putCarritoCliente({cantidad:cant,id:this.carrito[index].id})
                    this.editarCantCarrito({index:index,cantidad:cant})
                    this.cargando = false
                }else{
                    this.cargando = false
                    this.snackbar = true
                    this.snackbarColor ='error'
                    this.snackbarIcon = 'mdi-close-circle'
                    this.snackbarMsge='Sin stock compartido disponible'
                }
                
            } catch (error) {
                console.log(error);
                this.cargando = false
            }
        },
        async cantidadMenos(item){
            this.cargando = true
            try {
                let index = this.carrito.findIndex(i => i.cod_art==item.COD_ART)
                if(index>=0){
                    if(this.carrito[index].cantidad>1){
                        let cant = this.carrito[index].cantidad-1
                        await ApiServer.putCarritoCliente({cantidad:cant,id:this.carrito[index].id})
                        this.editarCantCarrito({index:index,cantidad:cant})
                    }else{
                        await ApiServer.deleteCarritoCliente(this.carrito[index].id)
                        this.borrarArtCarrito(this.carrito[index].id)
                    }
                }
                this.cargando = false
            } catch (error) {
                 console.log(error);
                this.cargando = false
            }
        },
        clicCant(){
            this.dialogCantidad = true
        },
        async cambiarCantidad(){
            this.dialogCantidad = false
            this.cargando = true
            try {
                let index = this.carrito.findIndex(i => i.cod_art==this.datosArt.COD_ART)
                let cant = this.carrito[index].cantidad
                if(this.puedeAsignarCantidadPorGrupo(this.datosArt,cant)){
                    await ApiServer.putCarritoCliente({cantidad:cant,id:this.carrito[index].id})
                    this.editarCantCarrito({index:index,cantidad:cant})
                }else{
                    this.snackbar = true
                    this.snackbarColor ='error'
                    this.snackbarIcon = 'mdi-close-circle'
                    this.snackbarMsge='Sin stock compartido disponible'
                }
                this.cargando = false
                
            } catch (error) {
                this.cargando = false
                this.dialogCantidad = false
                console.log(error);
            }
        },
        atras(){
            this.$router.go(-1)
        },
        async onFavorito(){
            try {
                if (!this.datosArt || !this.usuario) return
                await ApiServer.postFavorito({
                    cod_cli: this.usuario.cod_cli,
                    cod_art: this.datosArt.COD_ART
                })
                this.snackbar = true
                this.snackbarColor = 'success'
                this.snackbarIcon = 'mdi-check-circle'
                this.snackbarMsge = 'Artículo agregado a favoritos'
            } catch (error) {
                this.snackbar = true
                this.snackbarColor = 'error'
                this.snackbarIcon = 'mdi-close-circle'
                if (error.response && error.response.status === 409) {
                    this.snackbarMsge = 'El artículo ya está en favoritos'
                } else {
                    this.snackbarMsge = 'Se produjo un error'
                }
            }
        },
        async onAccesoRapido(){
            if (!this.datosArt || !this.usuario) return
            this.textoAccesoRapido = ''
            this.tieneAccesoRapido = false
            this.dialogAccesoRapido = true
            try {
                const result = await ApiServer.getAccesoRapido(this.usuario.cod_cli, this.datosArt.COD_ART)
                if (result && result.length > 0) {
                    this.textoAccesoRapido = result[0].texto
                    this.tieneAccesoRapido = true
                }
            } catch (error) {
                console.log(error)
            }
        },
        async guardarAccesoRapido(){
            if (!this.datosArt || !this.usuario) return
            const texto = (this.textoAccesoRapido || '').trim()
            if (!texto) return
            try {
                await ApiServer.postAccesoRapido({
                    cod_cli: this.usuario.cod_cli,
                    cod_art: this.datosArt.COD_ART,
                    texto
                })
                this.tieneAccesoRapido = true
                this.textoAccesoRapido = texto
                this.dialogAccesoRapido = false
                this.snackbar = true
                this.snackbarColor = 'success'
                this.snackbarIcon = 'mdi-check-circle'
                this.snackbarMsge = 'Acceso rápido guardado'
            } catch (error) {
                this.snackbar = true
                this.snackbarColor = 'error'
                this.snackbarIcon = 'mdi-close-circle'
                if (error.response && error.response.status === 409) {
                    this.snackbarMsge = 'Ese texto ya está en uso para otro artículo'
                } else {
                    this.snackbarMsge = 'Se produjo un error'
                }
            }
        },
        async eliminarAccesoRapido(){
            if (!this.datosArt || !this.usuario) return
            try {
                await ApiServer.deleteAccesoRapido(this.usuario.cod_cli, this.datosArt.COD_ART)
                this.tieneAccesoRapido = false
                this.textoAccesoRapido = ''
                this.dialogAccesoRapido = false
                this.snackbar = true
                this.snackbarColor = 'success'
                this.snackbarIcon = 'mdi-check-circle'
                this.snackbarMsge = 'Acceso rápido eliminado'
            } catch (error) {
                this.snackbar = true
                this.snackbarColor = 'error'
                this.snackbarIcon = 'mdi-close-circle'
                this.snackbarMsge = 'Se produjo un error'
            }
        },
        irCarrito(){
            this.$router.push({name: 'Carrito'});
        },
        irHome(){
            this.$router.push({name: 'Home'});
        },
        async clicArtComp(item){
            try {
                let result = await ApiServer.getArtLpr(item.COD_ART,this.datosArt.LISTA_ID,this.usuario.cli_id)
                console.log('resultLpr',result);
                if(result.length>0){
                    this.artComp = []
                    this.$router.push({name: 'Articulo', params: { codArt: item.COD_ART,datosArt:result[0] }});

                }
            } catch (error) {
                console.log(error);
            }
        },
        async cargar(){
            this.cargando = true
            if(!this.$route.params.codArt){
                this.$router.push({name: 'Home'});
            }else{
                if(!this.datosArticulo){
                    //BUSCAR EL ARTICULO
                    let lista = null
                    if(this.listaConsultada){
                        lista = this.listaConsultada
                    }else{
                        lista = this.usuario.listas[0].LISTA_ID
                    }
                    let resultArt = await ApiServer.getArtLpr(this.$route.params.codArt,lista,this.usuario.cli_id)
                    if(resultArt.length==0){
                        this.$router.go(-1)
                    }else{
                        if(resultArt.length>0){
                            if(resultArt[0].CANT_EMPAQ == 0){
                                resultArt[0].CANT_EMPAQ = 1
                            }
                        }
                        
                        this.datosArt = resultArt[0]
                        //SI TIENE DESCUENTO
                        // if(this.datosArt.DESCUENTO && this.datosArt.DESCUENTO>0){
                        //     this.datosArt.PR_FINAL = this.datosArt.PR_FINAL - this.datosArt.PR_FINAL * (this.datosArt.DESCUENTO/100)
                        //     this.datosArt.PR_VTA = this.datosArt.PR_VTA - this.datosArt.PR_VTA * (this.datosArt.DESCUENTO/100)
                        // }
                        let resultEtiqueta = await ApiServer.getEtiquetaProducto(this.$route.params.codArt)
                        this.datosArt.etiqueta = null
                        if(resultEtiqueta.length>0)
                            this.datosArt.etiqueta = `https://loguin.com.ar/img/imag_etiquetas/${resultEtiqueta[0].etiqueta}?t=${(new Date()).getTime()}`
                    }
                }else{
                    this.datosArt = this.datosArticulo
                }
                this.editarLista(this.datosArt.LISTA_ID)
                
                let resultImagenes = await ApiServer.getImagenesArt(this.datosArt.ART_ID)
                this.imagenes=[]
                if(resultImagenes.length>0){
                    resultImagenes.forEach(item => {
                        this.imagenes.push({url:item.url,tipo:item.tipo})
                    });
                }else{
                    this.imagenes.push({url:`https://www.loguin.com.ar/img/${this.datosArt.ART_ID}.jpg?t=${(new Date()).getTime()}`,tipo:'IMAGEN'})
                }
                this.cargando = false
                try {
                    let resultArtRel = await ApiServer.getArtRel(this.datosArt.COD_ART)
                    
                    for(const item of resultArtRel){
                        item.imagen=`https://www.loguin.com.ar/img/${item.ART_ID}.jpg`
                    }
                    this.artComp = resultArtRel
                } catch (error) {
                    console.log(error);
                }

                await ApiServer.postUsoLog({
                        cod_cli: this.usuario.cod_cli,
                        usuario: this.usuario.nombreUsuario,
                        accion: 'ARTICULO',
                        dato: this.datosArt.COD_ART
                    })
            }
        },
        clickImagen(item){
            console.log(item);
        },
        onErrorImg(item){
            item.imagen = require('../assets/default_image.png')
            this.componentKey++//PARA ACTUALIZAR
            
        },
        descEmpaque(item){

            let cant = this.carrito[this.carrito.findIndex(i => i.cod_art==item.COD_ART)].cantidad
            let empaque = item.ALQ_CANT_USO_DIARIO || item.CANT_EMPAQ
            if(cant==1){
                if(item.ESCALA != item.ESC){
                    return `${cant} ${item.ESCALA} / ${cant * empaque} ${item.ESC}`
                }else{
                    return `${cant} ${item.ESCALA}`
                }
            }else{
                if(item.ESCALA != item.ESC){
                    return `${cant} ${item.ESC_PLU} / ${cant * empaque} ${item.ESC}`
                }else{
                    return `${cant} ${item.ESC_PLU}`
                }
            }
        },
        cerrarDialogCambiarCantidad(){
            let index = this.carrito.findIndex(i => i.cod_art==this.datosArt.COD_ART)
            if(!this.puedeAsignarCantidadPorGrupo(this.datosArt,this.carrito[index].cantidad)){
                const maxUnidadesActual = this.disponibleGrupoParaItem(this.datosArt)
                this.carrito[index].cantidad = Math.floor(maxUnidadesActual / this.obtenerEmpaque(this.datosArt))
            }
            let cant = this.carrito[index].cantidad * this.obtenerEmpaque(this.carrito[index])
            if(cant<=0){
                this.carrito[index].cantidad = 1
            }
            this.dialogCantidad = false
        },
        porcentajeIva(){
            let x = this.datosArt.PR_FINAL/this.datosArt.PR_VTA
            if(Math.abs(21-(x-1)*100)<Math.abs(10.5-(x-1)*100)){
                return 21
            }else{
                return 10.5
            }
        },
        precioArt(){
            let precio = null
            if(this.precioConIva){
                precio = this.datosArt.PR_VTA + this.datosArt.PR_VTA*(this.datosArt.DESCUENTO/100)
            }else{
                precio = this.datosArt.PR_FINAL + this.datosArt.PR_FINAL*(this.datosArt.DESCUENTO/100)
            }
            if(this.datosArt.ALQ_CANT_USO_DIARIO){
                precio = precio / this.datosArt.ALQ_CANT_USO_DIARIO
            }
            return Math.round(precio)
        },
        precioPorEmpaque(){
            let precio = null
            if(this.precioConIva){
                let pr_vta= this.datosArt.PR_VTA + this.datosArt.PR_VTA*(this.datosArt.DESCUENTO/100)
                if(this.datosArt.ALQ_CANT_USO_DIARIO){//si ALQ_CANT_USO_DIARIO es != NULL el precio ya es por empaque
                    precio = Math.round(pr_vta)
                }else{
                    precio = Math.round(pr_vta)*this.datosArt.CANT_EMPAQ
                }
            }else{
                let pr_final = this.datosArt.PR_FINAL + this.datosArt.PR_FINAL*(this.datosArt.DESCUENTO/100)
                if(this.datosArt.ALQ_CANT_USO_DIARIO){//si ALQ_CANT_USO_DIARIO es != NULL el precio ya es por empaque
                    precio = Math.round(pr_final)
                }else{
                    precio = Math.round(pr_final)*this.datosArt.CANT_EMPAQ
                }
                
            }
            return precio
        },
        verImagen(imagen){
            this.imagenSelected = imagen
            this.dialogVerImagen = true
        },
        async pedidoAsesoramiento(item){
            this.itemCotizar = item
            this.cantCotizarItem = 1
            try {
                this.cargando = true
                this.textoCargando = 'Generando cotización'
                let cliente = []
                let result = await ApiServer.getDatosCliente(this.usuario.cod_cli)
                if(result.length>0){
                    let index = result.findIndex(x=>x.DOM_CLASIF_ID.trim()=='DE')
                    if(index>=0){
                        cliente = result[index]
                    }else{
                        cliente = result[0]
                    }
                }
                //TALONARIO
                let talonario = await ApiServer.getTalonarios(265);
                await ApiServer.putTalonarios(265)//TALONARIOS.NRO_CPR + 1
                let fecha = moment().format('DD-MM-YYYY')
                fecha = fecha.replace('-','.')
                fecha = fecha.replace('-','.')
                try {
                    let cpr_id = await ApiServer.getCprIdProcedure()
                    await ApiServer.postCpr({
                        id_pp:cpr_id.CPR_ID,
                        cpretc:11,
                        cprclasif:0,
                        cpr_tipo:"PR",
                        pv:talonario[0].NRO,
                        nro:talonario[0].NRO_CPR,
                        cpr_letra:"X",
                        tal_id:265,
                        fecha: fecha,
                        cli_id:this.usuario.cli_id,
                        rz:cliente.RZ,
                        cuit:cliente.CUIT,
                        iva_id:cliente.IVA_ID.trim(),
                        actividad:cliente.IB_ACTIV_ID,
                        dom:cliente.DOM,
                        loc_id:cliente.LOC_ID,
                        loc:cliente.LOCALIDAD,
                        cp:cliente.CP,
                        prov_id:cliente.PROVINCIA_ID,
                        tipo_pago_id:"CO",
                        lista_id:0,
                        lista:'LISTA BASE',
                        nota_cpr:"",
                        cond_id:'1',
                        computa_iva:(this.usuario.iva_id=='MO' || this.usuario.iva_id=='RI')?'S':'N',
                        discrimina_imp:(this.usuario.iva_id=='MO' || this.usuario.iva_id=='RI')?'S':'N'
                    })
                    //INSERTO CPRDET
                    try {
                        let MTOTAL = 0
                        let MTOTALN = 0
                        let IVA21 = 0
                        let IVA105 = 0
                        
                        let cprdet_id =await ApiServer.postCprDet({ //ME RETORNA EL CPRDET_ID
                            id_pp:cpr_id.CPR_ID,
                            art_id:this.itemCotizar.ART_ID,
                            cod_art:this.itemCotizar.COD_ART,
                            descripcion:this.itemCotizar.DESCRIPCION,
                            desc_cliente:this.itemCotizar.DESC_CLIENTE,
                            mod:this.itemCotizar.MOD,
                            med:this.itemCotizar.MED,
                            descif:this.itemCotizar.DESC_IF,
                            cant:(this.itemCotizar.CANT_EMPAQ==0)?(this.cantCotizarItem):(this.cantCotizarItem*this.itemCotizar.CANT_EMPAQ),
                            escala_id:this.itemCotizar.ESCALA_ID,
                            escala:this.itemCotizar.ESCALA,
                            lista_id:this.itemCotizar.LPR_ID,
                            pr_cto_cpra:this.itemCotizar.PR_CTO_CPRA,
                            pr_cto:this.itemCotizar.PR_CTO,
                            prfinal:this.itemCotizar.PR_FINAL,
                            pr_vta:this.itemCotizar.PR_VTA,
                            dep_id_org:33,
                            dep_id_dest:33,
                            porc_dr:0,
                            monto_dr:0
                        }) 
                        //INSERTO CPRDETIMP
                        let PRNETO = this.itemCotizar.PR_VTA
                        let PRFINAL = this.itemCotizar.PR_FINAL
                        let IMPU=0
                        let IMP_ID=0
                        if(this.itemCotizar.CANT_EMPAQ>1){
                            PRNETO = this.itemCotizar.PR_VTA*this.itemCotizar.CANT_EMPAQ
                            PRFINAL = this.itemCotizar.PR_FINAL*this.itemCotizar.CANT_EMPAQ
                        }
                        if(((PRFINAL/PRNETO)-1.21)<=0.01){
                            IVA21=IVA21+(PRNETO*.21*(this.cantCotizarItem));
                            IMPU=21;
                            IMP_ID=1;
                        }
                        if(((PRFINAL/PRNETO)-1.105)<=0.01){
                            IVA105=IVA105+(PRNETO*.105*(this.cantCotizarItem));
                            IMPU=10.5;
                            IMP_ID=2;
                        }
                        await ApiServer.postCprdetImp({
                            cprdet_id:cprdet_id.CPRDET_ID,
                            imp_id:IMP_ID,
                            impu:IMPU,
                            neto_mas_iva:PRNETO*this.cantCotizarItem,
                            monto_iva:PRNETO*(IMPU/100)*(this.cantCotizarItem)
                        })
                        //SUMO LOS TOTALES
                        MTOTAL=MTOTAL+(PRFINAL)*(this.cantCotizarItem);
                        MTOTALN=MTOTALN+(PRNETO)*(this.cantCotizarItem);

                        
                        //INSERTO EL PIE DEL COMPROBANTE
                        try {
                            await ApiServer.postCprpie({
                                cpr_id:cpr_id.CPR_ID,
                                impuesto_id:'-1',
                                porc:'0',
                                porcentaje:'0',
                                total_neto:MTOTALN,
                                total:MTOTAL
                            });
                            await ApiServer.postCprpie({
                                cpr_id:cpr_id.CPR_ID,
                                impuesto_id:'0',
                                porc:'0',
                                porcentaje:'0',
                                total_neto:MTOTALN,
                                total:MTOTAL
                            });
                            if(IVA21>=0.01){
                                await ApiServer.postCprpie({
                                cpr_id:cpr_id.CPR_ID,
                                impuesto_id:'1',
                                impuesto:'IVA 21%',
                                clasif_id:'1',
                                porc:'21',
                                porcentaje:'0',
                                total_neto:IVA21,
                                total:IVA21/1.21,
                                });
                            }
                            if(IVA105>=0.01){
                                await ApiServer.postCprpie({
                                cpr_id:cpr_id.CPR_ID,
                                impuesto_id:'2',
                                impuesto:'IVA 10.5%',
                                clasif_id:'1',
                                porc:'10.5',
                                porcentaje:'0',
                                total_neto:IVA105,
                                total:IVA105/1.105,
                                }); 
                            }
                            try {
                                await ApiServer.putCprMonto(cpr_id.CPR_ID,{monto:MTOTAL})
                                try {
                                    //CAMBIAR EL ESTADO A CPR_EST_ID=1
                                    await ApiServer.putCprEstado(cpr_id.CPR_ID,{estado:'1'})
                                } catch (error) {
                                    this.cargando=false
                                    console.log(error)
                                    this.snackbar=true
                                    this.snackbarMsge="Se produjo un error"
                                    this.snackbarColor="error"
                                    this.snackbarIcon='mdi-close-circle'
                                }
                            } catch (error) {
                                this.cargando=false
                                console.log(error)
                                this.snackbar=true
                                this.snackbarMsge="Se produjo un error"
                                this.snackbarColor="error"
                                this.snackbarIcon='mdi-close-circle' 
                            }
                        } catch (error) {
                            this.cargando=false
                            console.log(error)
                            this.snackbar=true
                            this.snackbarMsge="Se produjo un error"
                            this.snackbarColor="error"
                            this.snackbarIcon='mdi-close-circle'
                        }
                    } catch (error) {
                        this.cargando=false
                        console.log(error)
                        this.snackbar=true
                        this.snackbarMsge="Se produjo un error"
                        this.snackbarColor="error"
                        this.snackbarIcon='mdi-close-circle'
                    }
                    this.cargando=false
                    this.dialogAsesoramiento = true
                    
                } catch (error) {
                    this.cargando=false
                    console.log(error)
                    this.snackbar=true
                    this.snackbarMsge="Se produjo un error"
                    this.snackbarColor="error"
                    this.snackbarIcon='mdi-close-circle'
                }
            } catch (error) {
                this.cargando=false
                console.log(error);
                this.snackbar = true
                this.snackbarColor ='error'
                this.snackbarIcon = 'mdi-close-circle'
                this.snackbarMsge='Se produjo un error'
            }
        }
    },
    computed:{
         ...mapState(['listaConsultada','usuario','carrito']),
         validarCantidad(){
             let index = this.carrito.findIndex(i => i.cod_art==this.datosArt.COD_ART)
             if(index>=0){
                return this.puedeAsignarCantidadPorGrupo(this.datosArt,this.carrito[index].cantidad)
            }else{
                return false
            }
         },
         sinDisponibilidadCantidad(){
             if(!this.datosArt){
                 return false
             }
             let index = this.carrito.findIndex(i => i.cod_art==this.datosArt.COD_ART)
             if(index < 0){
                 return false
             }
             const cant = Number(this.carrito[index].cantidad)
             if(!cant || cant <= 0){
                 return false
             }
             return !this.puedeAsignarCantidadPorGrupo(this.datosArt, cant)
         },
        precioConIva(){
            if(this.usuario.iva_id=='MO' || this.usuario.iva_id=='RI'){
                return true
            }else{
                return false
            }
        },
        
    },
   
    mounted(){
        this.cargar()
    },
    created() {
        this.$watch(() => this.$route.params,
        (toParams, previousParams) => {
            this.cargar()
        }
        )
    },
}
</script>

<style scoped>
    .row-pointer >>> tbody tr :hover {
    cursor: pointer;
    }
    .caroucel >>> .v-image__image--cover{
        background-size: contain
    }
    .centered-input >>> input {
      text-align: center
    }
    .cant.v-text-field--outlined >>> fieldset {
    border-color: orange;
    border-width: 2px;
    height: 35px;
    align-self: start;
    margin-top: 6px
    }
    .fixed-bar {
        position: sticky;
        position: -webkit-sticky; /* for Safari */
        top: 0em;
        z-index: 2;
    }
    .caroucel >>> .v-window__next,
    .caroucel >>> .v-window__prev {
        background: #ff9800 !important; /* Cambia el color de las flechas */
    }
    .cantidad-controls {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        flex-wrap: nowrap;
    }
    .cantidad-input {
        flex-shrink: 0;
        min-width: 70px;
    }
</style>